"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _connect = require("../actions/connect");

var _createPromiseQueue2 = _interopRequireDefault(require("../createPromiseQueue"));

var _setNotification = _interopRequireDefault(require("../actions/setNotification"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(connectionStatusToNotification),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(_callee);

var CONNECTIVITY_STATUS_NOTIFICATION_ID = 'connectivitystatus';

function subscribeToPromiseQueue(observable) {
  var _createPromiseQueue = (0, _createPromiseQueue2["default"])(),
      push = _createPromiseQueue.push,
      shift = _createPromiseQueue.shift;

  var subscription = observable.subscribe({
    next: push
  });
  return {
    shift: shift,
    unsubscribe: function unsubscribe() {
      subscription.unsubscribe();
    }
  };
}

function connectionStatusToNotification(_ref) {
  var directLine, _subscribeToPromiseQu, shift, unsubscribe, reconnecting, value;

  return _regenerator["default"].wrap(function connectionStatusToNotification$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          directLine = _ref.payload.directLine;
          _subscribeToPromiseQu = subscribeToPromiseQueue(directLine.connectionStatus$), shift = _subscribeToPromiseQu.shift, unsubscribe = _subscribeToPromiseQu.unsubscribe;
          _context.prev = 2;

        case 3:
          _context.next = 5;
          return (0, _effects.call)(shift);

        case 5:
          value = _context.sent;
          _context.t0 = value;
          _context.next = _context.t0 === 0 ? 9 : _context.t0 === 1 ? 9 : _context.t0 === 2 ? 12 : _context.t0 === 3 ? 16 : _context.t0 === 4 ? 16 : 20;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)((0, _setNotification["default"])({
            id: CONNECTIVITY_STATUS_NOTIFICATION_ID,
            level: 'info',
            message: reconnecting ? 'reconnecting' : 'connecting'
          }));

        case 11:
          return _context.abrupt("break", 21);

        case 12:
          reconnecting = 1;
          _context.next = 15;
          return (0, _effects.put)((0, _setNotification["default"])({
            id: CONNECTIVITY_STATUS_NOTIFICATION_ID,
            level: 'success',
            message: 'connected'
          }));

        case 15:
          return _context.abrupt("break", 21);

        case 16:
          reconnecting = 1;
          _context.next = 19;
          return (0, _effects.put)((0, _setNotification["default"])({
            id: CONNECTIVITY_STATUS_NOTIFICATION_ID,
            level: 'error',
            message: 'failedtoconnect'
          }));

        case 19:
          return _context.abrupt("break", 21);

        case 20:
          return _context.abrupt("break", 21);

        case 21:
          _context.next = 3;
          break;

        case 23:
          _context.prev = 23;
          unsubscribe();
          return _context.finish(23);

        case 26:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2,, 23, 26]]);
}

function _callee() {
  return _regenerator["default"].wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_connect.CONNECT, connectionStatusToNotification);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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